import { DataGrid } from "@mui/x-data-grid";
import { observer } from "mobx-react-lite";
import { orderStorage } from "../../services/shop/OrderStorage";
import React from "react";
import "./OrderTable.scss";
import { Typography } from "@mui/material";
import { translationService } from "../../services/translation/TranslationService";

export default observer(function OrderTable() {
  return (
    <div className="base-data-table">
      <Typography variant="caption" sx={{ mb: 1, fontWeight: 500 }}>
        {translationService.translate("shop.activity-prices.table-name")}
      </Typography>
      <DataGrid
        columns={orderStorage.columns}
        rows={orderStorage.rows}
        rowHeight={40}
        hideFooter
        disableColumnMenu
        disableRowSelectionOnClick
      />
    </div>
  );
});
